import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import FlagTeam from '@assets/images/placeholder/team-placeholder.svg'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import dynamic from 'next/dynamic'
import { RightBracketArrow } from '../ctIcons'
import playerImg from '@assets/images/placeholder/Placeholder_Player.svg'
const MyImage = dynamic(() => import('@shared/components/myImage'))

function CurrentSeries({ data, cardtitle, urlStat, titleData, titleFirst, dataProperty }) {
  return (
    <>
      {data?.fetchSeriesStats &&
        <section>
          <div className={`font-semi items common-box p-0 ${styles.wtc2023}`}>
            <>
              <div className={`position-relative ${styles.borderRadius} ${styles.bgGrey}`}>
                <h3>{cardtitle}</h3>
              </div>
              <div className={styles.iccLinks}>
                {data?.fetchSeriesStats?.slice(0, 3).map((series, index) => {
                  return (
                    <>
                      {index === 0 ? (
                        <div className='d-flex justify-content-between'>
                          <div className="cs-item ">
                            {series?.oPlayer?.eTagStatus === 'a' ? <a href={'/' + series?.oPlayer?.oSeo?.sSlug} className="overflow-hidden text-nowrap d-flex">{series?.oPlayer?.sFullName}</a> : <p className="overflow-hidden text-nowrap d-flex">{series?.oPlayer?.sFullName} </p>
                            }
                            <div className='mb-0 mt-2 d-flex'>
                              <div className={styles.flag}>
                                <MyImage
                                  src={series?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${series?.oTeam?.oImg?.sUrl}` : FlagTeam}
                                  placeholderImage={FlagTeam}
                                  width="162"
                                  height="162"
                                  alt={data?.oPlayer?.oImg?.sText}
                                  layout="responsive"
                                  autoRadiusImage
                                  sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                                />
                              </div>
                              <div className={`mb-0' ${styles.runs}`}>
                                &nbsp; &nbsp; {series?.oTeam?.sTitle}
                                {data.oTeam?.oImg?.sUrl}
                              </div>
                            </div>

                            <div className={`overflow-hidden text-nowrap d-flex py-3 ${styles.boldText}`}>
                              {titleFirst != null || undefined ? series?.[dataProperty] : series?.nRuns}
                              <div className={` ${styles.ml8} ${styles.runs}`}>{titleFirst != null || undefined ? titleFirst : 'Runs'} </div>
                            </div>

                          </div>
                          <div>
                            <div className={`${styles.playerPic} overflow-hidden`}>
                              <MyImage src={series?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${series?.oPlayer?.oImg?.sUrl}` : playerImg} alt="user" blurDataURL={BLUR_DATA_URL_BASE64} placeholder="blur" layout="responsive" width="40" height="40" autoRadiusImage/>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="cs-item d-flex justify-content-between">
                          <div className="overflow-hidden text-nowrap d-flex">
                            {series?.oPlayer?.eTagStatus === 'a' ? <a href={'/' + series?.oPlayer?.oSeo?.sSlug} className="overflow-hidden text-nowrap d-flex">
                              <div className={`mb-0 ${styles.index}`}> {index + 1}.</div>
                              &nbsp;{series?.oPlayer?.sFullName}</a> : <div className="overflow-hidden text-nowrap d-flex">
                              <div className={`mb-0 ${styles.index}`}> {index + 1}.</div>
                              &nbsp;{series?.oPlayer?.sFullName}</div>
                            }
                            <div className={`mb-0' ${styles.runs}`}>  &nbsp;&nbsp;({series?.oTeam?.sAbbr})</div>
                          </div>
                          <div className={`overflow-hidden text-nowrap d-flex ${styles.runs}`}>{titleFirst != null || undefined ? series?.[dataProperty] : series?.nRuns} {titleFirst != null || undefined ? titleFirst : 'Runs'} </div>
                        </div>
                      )}
                    </>
                  )
                })}
                {urlStat ? (<div className={`${styles.fullLink} cs-item d-flex flex-row-reverse`}>
                  <a href={urlStat} className="overflow-hidden text-nowrap d-flex">View Full Table
                    <div className={`${styles.iccContent}`}>
                      <RightBracketArrow />
                    </div>
                  </a>
                </div>) : ('')
                }
              </div>
            </>
          </div>
        </section>
      }
    </>
  )
}

CurrentSeries.propTypes = {
  // dataSSR: PropTypes.object,
  data: PropTypes.object,
  cardtitle: PropTypes.string,
  urlStat: PropTypes.string,
  titleData: PropTypes.string,
  titleFirst: PropTypes.string,
  dataProperty: PropTypes.string
}

export default CurrentSeries
